import { render, staticRenderFns } from "./CounselorTable.vue?vue&type=template&id=84cf426e&scoped=true&"
import script from "./CounselorTable.vue?vue&type=script&lang=js&"
export * from "./CounselorTable.vue?vue&type=script&lang=js&"
import style0 from "./CounselorTable.vue?vue&type=style&index=0&id=84cf426e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84cf426e",
  null
  
)

export default component.exports